import React, { useState } from "react";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";

export const EditRememberOption = ({
  activitiesObject,
  statesObject,
  selectedItemData,
  setSelectedItemData,
  gatewayObject
}) => {
  let activitiesKeyArray = Object.keys(activitiesObject);
  let statesKeyArray = Object.keys(statesObject);
  let rememberItemsArray = [
    "allow_state_targets",
    "deny_states_targets",
    "allow_activities",
    "source_activity",
    "allow_state_sources",
    "deny_states_sources",
    "deny_activities"
  ];

  const handleChangeInArray = (newArray, key) => {
    let rememberObj = { ...selectedItemData };
    rememberObj.remember[key] = newArray.map((a) => a.id);
    setSelectedItemData(rememberObj);
  };
  const [toggleState, setToggleState] = useState(true);

  return (
    <div className="sm_blueprint_editBox builder_form">
      <div className="inline_tag_items" style={{ marginBottom: "12px" }}>
        <div className="advanced_settings">Advanced settings</div>
        <div className={`toggle_switch ${toggleState ? "" : "active"}`} onClick={() => setToggleState(!toggleState)}>
          <div className="toggle_slider"></div>
        </div>
      </div>

      {rememberItemsArray.map((rememberKey, index) => {
        let rememberArray = selectedItemData.remember[rememberKey];
        if ([0, 1, 4, 5].includes(index)) {
          let statesNameArray = [];
          for (let index = 0; index < statesKeyArray.length; index++) {
            const statesKey = statesKeyArray[index];
            statesNameArray.push({
              name: statesObject[statesKey].name,
              id: statesKey
            });
          }
          let rememberNameArray = [];
          if (rememberArray && Array.isArray(rememberArray)) {
            for (let index = 0; index < rememberArray.length; index++) {
              const statesKey = rememberArray[index];
              rememberNameArray.push({
                name: statesObject[statesKey].name,
                id: statesKey
              });
            }
          }
          if (toggleState && index !== 0) {
            if (rememberNameArray.length === 0) {
              return undefined;
            }
          }
          return (
            <MultiSelectBox
              key={rememberKey}
              label={rememberKey.split("_").join(" ")}
              options={statesNameArray}
              selectedData={rememberNameArray}
              onChange={(newData) => handleChangeInArray(newData, rememberKey)}
            />
          );
        } else {
          let activitiesNameArray = [];
          for (let index = 0; index < activitiesKeyArray.length; index++) {
            const activitiesKey = activitiesKeyArray[index];
            if (!activitiesKey || !activitiesObject[activitiesKey]) continue;
            activitiesNameArray.push({
              name: activitiesObject[activitiesKey].name,
              id: activitiesKey
            });
          }
          let rememberNameArray = [];
          if (rememberArray && Array.isArray(rememberNameArray)) {
            for (let index = 0; index < rememberArray.length; index++) {
              const activitiesKey = rememberArray[index];
              if (!activitiesKey || !activitiesObject[activitiesKey]) continue;
              rememberNameArray.push({
                name: activitiesObject[activitiesKey].name,
                id: activitiesKey
              });
            }
          }
          if (toggleState && index !== 2) {
            if (rememberNameArray.length === 0) {
              return undefined;
            }
          }
          return (
            <MultiSelectBox
              key={rememberKey}
              label={rememberKey.split("_").join(" ")}
              options={activitiesNameArray}
              selectedData={rememberNameArray}
              onChange={(newData) => handleChangeInArray(newData, rememberKey)}
            />
          );
        }
      })}

      <MultiSelectBox
        key={"allow_gateway_targets"}
        label={"allow_gateway_targets".split("_").join(" ")}
        options={gatewayObject}
        selectedData={selectedItemData.remember.allow_gateway_targets}
        onChange={(newData) => handleChangeInArray(newData, "allow_gateway_targets")}
      />
    </div>
  );
};
